export const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#6366F1'];

// Lead Pipeline Stages per spec
export const STAGES = [
  'New',
  'Contacted',
  'Quoted',
  'Site Visited',
  'Won',
  'Lost'
];

// Stage colors for visual distinction
export const STAGE_COLORS = {
  'New': { bg: 'bg-blue-100', text: 'text-blue-700', border: 'border-blue-300' },
  'Contacted': { bg: 'bg-cyan-100', text: 'text-cyan-700', border: 'border-cyan-300' },
  'Quoted': { bg: 'bg-amber-100', text: 'text-amber-700', border: 'border-amber-300' },
  'Site Visited': { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-300' },
  'Won': { bg: 'bg-green-100', text: 'text-green-700', border: 'border-green-300' },
  'Lost': { bg: 'bg-red-100', text: 'text-red-700', border: 'border-red-300' }
};

// Why a lead was lost — asked once, when the lead moves to Lost.
//
// `klass` is never shown to the salesperson; it exists so analytics can
// separate "this was never a real deal" from "we lost a real one". Win rate
// measured against every raw inquiry (spam, wrong numbers, silent leads)
// understates the team badly; measured against qualified deals only, it
// answers the question an owner actually asks.
//
//   disqualified — never a genuine opportunity
//   lost         — a real deal that went elsewhere
//   nofault      — no deal to win; may come back
export const LOSS_REASON_CLASSES = ['lost', 'disqualified', 'nofault'];

export const LOSS_REASONS = [
  { id: 'price', label: 'Price / out of budget', klass: 'lost' },
  { id: 'competitor', label: 'Chose a competitor', klass: 'lost' },
  { id: 'date_unavailable', label: 'Date unavailable', klass: 'lost' },
  { id: 'out_of_area', label: 'Out of area', klass: 'lost' },
  { id: 'capacity', label: 'Capacity mismatch', klass: 'lost' },
  { id: 'other', label: 'Other', klass: 'lost' },
  { id: 'no_answer', label: 'Never answered / unreachable', klass: 'disqualified' },
  { id: 'not_serious', label: 'Just enquiring, not serious', klass: 'disqualified' },
  { id: 'invalid_contact', label: 'Invalid contact or spam', klass: 'disqualified' },
  { id: 'event_cancelled', label: 'Event cancelled', klass: 'nofault' },
  { id: 'postponed', label: 'Postponed to a later date', klass: 'nofault' }
];

export const LOSS_REASON_BY_ID = Object.fromEntries(LOSS_REASONS.map((r) => [r.id, r]));

// Reasons that mean "no genuine opportunity existed" — excluded from the
// qualified win rate.
export const DISQUALIFYING_REASONS = LOSS_REASONS.filter((r) => r.klass === 'disqualified').map((r) => r.id);

// Auto-triggers per stage
export const STAGE_TRIGGERS = {
  'New': 'AI sends greeting, assigns employee',
  'Contacted': 'Timer starts for follow-up',
  'Site Visited': 'Reminder to employee day before',
  'Quoted': 'Follow-up reminder if no response in 3 days',
  'Won': 'Push to invoicing software'
};

export const MANAGERS = ['Rafaqat Ali', 'Zia un Nabi', 'Hassan Rizvi', 'Khizar', 'Unassigned'];

export const ROLES = ['Admin', 'Owner', 'Sales', 'Finance'];

export const MASTER_EMAIL = "nadirbutt87@gmail.com";

// Stale lead thresholds (in hours)
export const STALE_THRESHOLDS = {
  REMINDER: 24,    // Remind employee after 24 hours
  ESCALATE: 48     // Escalate/reassign after 48 hours
};

// WhatsApp message templates
export const WA_TEMPLATES = {
  // English templates
  GREETING_ENGLISH: (venueName, employeeName) =>
    `Hello! Thank you for your interest in ${venueName}. Our representative ${employeeName} will contact you shortly.\n\n📋 Conversations are recorded for quality purposes.`,
  GREETING_ENGLISH_SHORT: (venueName, employeeName) =>
    `Hi! Thanks for contacting ${venueName}. ${employeeName} will reach out soon. 📋 Calls recorded for quality.`,
  // Urdu templates
  GREETING_URDU: (venueName, employeeName) =>
    `Assalam o Alaikum! ${venueName} mein inquiry ka shukriya. Hamara representative ${employeeName} aap se jaldi rabta karega. Shukriya!\n\n📋 Is number pe baat cheet service quality ke liye record ki jati hai.`,
  GREETING_URDU_SHORT: (venueName, employeeName) =>
    `Assalam o Alaikum! ${venueName} se. ${employeeName} jaldi aap se rabta karega. 📋 Baat cheet record ki jati hai.`,
  // Internal notifications
  LEAD_ASSIGNED_URDU: (clientName, eventDate, guestCount) =>
    `Naya lead assign hua: ${clientName}, ${eventDate || 'Date pending'}, ${guestCount || 'Guests TBD'}`,
  LEAD_ASSIGNED_ENGLISH: (clientName, eventDate, guestCount) =>
    `New lead assigned: ${clientName}, ${eventDate || 'Date pending'}, ${guestCount || 'Guests TBD'}`
};

// Venue info
export const VENUE = {
  name: 'Area 51 Banquet Hall',
  whatsappNumber: '' // Will be set from integrations
};

// Available venues
export const VENUES = [
  { id: 'marquee', name: 'Marquee', label: 'Area 51 Marquee' },
  { id: 'banquet', name: 'Banquet', label: 'Area 51 Banquet Hall' }
];

// Payment milestones
export const PAYMENT_MILESTONES = ['Advance', 'Mid-payment', 'Final payment'];

// Event types
export const EVENT_TYPES = [
  'Wedding',
  'Mehndi',
  'Engagement',
  'Birthday',
  'Corporate Event',
  'Other'
];
